import { useRef } from 'react';
import intl from 'components/i18n/ReactIntlWrapper';
import PdfViewer from '../../common/PdfRenderer';
import { Grid, Button, Typography } from '@mui/material';
import { useInvoice } from '../../common/InvoiceProvider';

const InvoiceUploadDropZone = ({ review = false, view = false }) => {
  const { input, setInput, errors } = useInvoice();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file?.type === 'application/pdf') {
      setInput((prevInput) => ({
        ...prevInput,
        attachments: [file],
      }));
    }
  };

  const handleDeletePDF = () => {
    setInput((prevInput) => ({
      ...prevInput,
      attachments: null,
    }));
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div>
      <Typography
        variant="body2"
        color={errors?.attachments ? 'error' : 'inherit'}
        style={{ marginTop: errors?.attachments ? '-30px' : '0px' }}
      >
        {errors?.attachments && <span>{errors?.attachments}</span>}
      </Typography>
      {!input?.attachments?.[0] ? (
        <div
          style={{
            display: review ? 'none' : 'flex',
            minHeight: '600px',
            marginRight: '20px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <input
            ref={fileInputRef}
            type="file"
            accept="application/pdf"
            onChange={handleFileSelect}
            style={{ display: 'none' }}
            disabled={view}
          />
          <Grid container justifyContent="center">
            <Grid sx={{ xs: 12, md: 7, lg: 7, xl: 7 }}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleUploadClick}
                disabled={view}
              >
                {intl.get('newInvoice.uploadInvoice')}
              </Button>
              <Typography
                variant="body2"
                style={{ marginTop: '10px' }}
                className="dropZoneText"
                align="center"
              >
                {intl.get('newInvoice.addInvoiceText')}
              </Typography>
            </Grid>
          </Grid>
        </div>
      ) : (
        <div>
          <Grid container justifyContent="center" style={{ paddingRight: '10px' }}>
            <PdfViewer
              file={review ? null : input?.attachments?.[0]}
              dataURI={input?.attachments?.[0]?.dataUri}
            />
          </Grid>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                display: review || view ? 'none' : '',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              onClick={handleDeletePDF}
            >
              -{intl.get('newInvoice.removeInvoice')}
            </Typography>
          </Grid>
        </div>
      )}
    </div>
  );
};

export default InvoiceUploadDropZone;
